import React from 'react';

import type { ToolCall } from '../types';
import { ToolChip } from '../styles';

export function ToolCallIndicator({ toolCall }: { toolCall: ToolCall }) {
  return (
    <ToolChip title={JSON.stringify(toolCall.args, null, 2)}>
      <span aria-hidden="true">⚙</span>
      {toolCall.name}
    </ToolChip>
  );
}
